import { render, staticRenderFns } from "./Parceiro.vue?vue&type=template&id=b0d427f6"
import script from "./Parceiro.vue?vue&type=script&lang=js"
export * from "./Parceiro.vue?vue&type=script&lang=js"
import style0 from "./Parceiro.vue?vue&type=style&index=0&id=b0d427f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports